import { render, staticRenderFns } from "./StockPlates.vue?vue&type=template&id=f1072c64"
import script from "./StockPlates.vue?vue&type=script&lang=js"
export * from "./StockPlates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports